import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageDropdown({ selectedLanguage, onLanguageChange }) {
  const { t, i18n } = useTranslation();

  const languages = [
    { value: "english", label: "English" },
    { value: "amharic", label: "Amharic" },
    { value: "arabic", label: "Arabic" },
    { value: "bengali", label: "Bengali" },
    { value: "chinese", label: "Chinese" },
    { value: "ethiopian", label: "Ethiopian" },
    { value: "filipino", label: "Filipino (Tagalog)" },
    { value: "french", label: "French" },
    { value: "gujarati", label: "Gujarati" },
    { value: "german", label: "German" },
    { value: "hebrew", label: "Hebrew" },
    { value: "hindi", label: "Hindi" },
    { value: "igbo", label: "Igbo" },
    { value: "italian", label: "Italian" },
    { value: "japanese", label: "Japanese" },
    { value: "korean", label: "Korean" },
    { value: "mandarin", label: "Mandarin" },
    { value: "oromo", label: "Oromo" },
    { value: "portuguese", label: "Portuguese" },
    { value: "spanish", label: "Spanish" },
    { value: "swahili", label: "Swahili" },
    { value: "tigrinya", label: "Tigrinya" },
    { value: "wolof", label: "Wolof" },
  ];

  const languageCodeMap = {
    english: "en",
    amharic: "am",
    arabic: "ar",
    bengali: "bn",
    chinese: "zh",
    ethiopian: "am",
    filipino: "fil",
    french: "fr",
    gujarati: "gu",
    german: "de",
    hebrew: "he",
    hindi: "hi",
    igbo: "ig",
    italian: "it",
    japanese: "ja",
    korean: "ko",
    mandarin: "zh",
    oromo: "om",
    portuguese: "pt",
    spanish: "es",
    swahili: "sw",
    tigrinya: "ti",
    wolof: "wo",
  };

  // Keep the translation label synchronized with the actual dropdown value.
  // If Hub returns with selectedLanguage="english", the label also returns
  // to English immediately.
  useEffect(() => {
    const code = languageCodeMap[selectedLanguage] || "en";
    if (i18n.language !== code) {
      i18n.changeLanguage(code);
    }
  }, [selectedLanguage, i18n]);

  const handleLanguageChange = async (nextLanguage) => {
    const code = languageCodeMap[nextLanguage] || "en";

    // Update the i18n label immediately.
    await i18n.changeLanguage(code);

    // Keep your existing Hub/data.js language behavior unchanged.
    if (typeof onLanguageChange === "function") {
      onLanguageChange(nextLanguage);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
      }}
    >
      <label
        htmlFor="language-selector"
        style={{
          fontSize: "13px",
          color: "#4b1d95",
          marginBottom: "6px",
          marginTop: "5px",
          textAlign: "left",
          fontWeight: 700,
        }}
      >
        {t("changeLanguage", "Change Language")}
      </label>

      <select
        id="language-selector"
        value={selectedLanguage}
        onChange={(e) => handleLanguageChange(e.target.value)}
        style={{
          width: "100%",
          minHeight: "44px",
          padding: "8px 12px",
          fontSize: "16px",
          borderRadius: "12px",
          border: "1px solid #d8c8f0",
          backgroundColor: "#ffffff",
          color: "#24173a",
          boxSizing: "border-box",
        }}
      >
        {languages.map((lang) => (
          <option key={lang.value} value={lang.value}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageDropdown;
